import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppContext } from '../../../app/Context';
import routes from '../../../routes/router';

const useAuthenticated = () => {
  const navigate = useNavigate();

  const { session } = useAppContext();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(
    function navigateToLogin() {
      if (session && session?.token) {
        setIsLoading(false);
        return;
      }
      navigate(routes.auth.url(), { replace: true });
    },
    [navigate, session, session?.token]
  );

  return { isLoading };
};

export default useAuthenticated;
